module.exports = __webpack_public_path__ + "img/postgres-sql-logo.7d7713e2.png";